import React, { useState } from 'react';
import { Alert, Platform } from 'react-native';
import { Center, Button, Modal, FormControl, WarningOutlineIcon, Text, useTheme } from 'native-base';
import { DEVICE_WIDTH } from '../Constants';
import { useModeratorDispatch } from '../../context/moderator';
import Confirm from '../content/common/reusables/Confirm';
import ChooseCategory from '../content/topics/ChooseCategory';
const ChangeTopicCategory = ({
  topic,
  showModal,
  setShowModal,
  updateTopicCategory
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const moderatorDispatch = useModeratorDispatch();
  const currentCategory = topic === null || topic === void 0 ? void 0 : topic.category_id;
  const [selectionMade, setSelectionMade] = useState(false);
  const [selectedPostCategoryId, setSelectedPostCategoryId] = useState(topic === null || topic === void 0 ? void 0 : topic.category_id);
  const [selectedCategory, setSelectedCategory] = useState({});
  const isDestinationSame = currentCategory === selectedPostCategoryId;
  const handleChangeCategory = async () => {
    const onConfirmYes = async () => {
      await updateTopicCategory(topic === null || topic === void 0 ? void 0 : topic.id, selectedCategory.id);
      setShowModal(false);
    };
    if (!isDestinationSame) {
      const title = 'Confirm';
      const message = `Changing the category of this topic to "${selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name}". Proceed?`;
      const buttons = [{
        text: 'Yes',
        onPress: onConfirmYes
      }, {
        text: 'Cancel',
        style: 'cancel'
      }];
      if (Platform.OS === 'web') {
        return Confirm.confirm(title, message, buttons, onConfirmYes);
      } else {
        return Alert.alert(title, message, buttons);
      }
    }
  };
  return /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: showModal,
    onClose: () => setShowModal(false)
  }, /*#__PURE__*/React.createElement(Modal.Content, {
    maxWidth: Platform.OS === 'web' ? null : DEVICE_WIDTH
  }, /*#__PURE__*/React.createElement(Modal.CloseButton, null), /*#__PURE__*/React.createElement(Modal.Header, null, "Change Topic Category"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(FormControl, {
    isRequired: true,
    isInvalid: !selectedPostCategoryId
  }, /*#__PURE__*/React.createElement(FormControl.Label, null, "Choose category"), /*#__PURE__*/React.createElement(ChooseCategory, {
    key: "chooseCategory",
    selectedPostCategoryId: selectedPostCategoryId,
    setSelectedPostCategoryId: setSelectedPostCategoryId,
    setCategoryObject: setSelectedCategory,
    setIsCategoryValid: setSelectionMade
  }), !selectedPostCategoryId && /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.changeCategory.message,
    leftIcon: /*#__PURE__*/React.createElement(WarningOutlineIcon, {
      size: 'xs'
    })
  }, "Please select one."), selectedCategory && isDestinationSame && selectionMade && /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.changeCategory.message
  }, "This topic is already in #", selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name, " category."))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button.Group, {
    space: 2
  }, /*#__PURE__*/React.createElement(Button, {
    variant: 'ghost',
    colorScheme: 'blueGray',
    onPress: () => setShowModal(false)
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    isDisabled: isDestinationSame,
    onPress: () => handleChangeCategory()
  }, "Change"))))));
};
export default ChangeTopicCategory;
//# sourceMappingURL=ChangeTopicCategory.js.map